























import { Component, Vue, Model, Emit } from 'vue-property-decorator'
import Header from './header.vue'
import Menu from './menu.vue'

import Driver from 'driver.js' // import driver.js
import 'driver.js/dist/driver.min.css' // import driver.js css
import { steps } from '../../unite/guild'
import Breadcrumb from '../../components/Breadcrumb.vue'
import TagsView from '../../components/TagsView.vue'

@Component({
  components: {
    Header,
    Menu,
    Breadcrumb,
    TagsView
  }
})
export default class Layout extends Vue {
  guildData: any = new steps()
  driver: any
  timer: any
  breadcrumb: any = [{ name: '首页', index: '/home' }]
  created() {
    // this.refreshToken()
  }
  mounted() {
    this.driver = new Driver({
      className: 'scoped-class', // className to wrap driver.js popover
      animate: true, // Animate while changing highlighted element
      opacity: 0.75, // Background opacity (0 means only popovers and without overlay)
      padding: 10, // Distance of element from around the edges
      allowClose: false, // Whether clicking on overlay should close or not
      overlayClickNext: false, // Should it move to next step on overlay click
      doneBtnText: '完成', // Text on the final button
      closeBtnText: '关闭', // Text on the close button for this step
      nextBtnText: '下一步', // Next button text for this step
      prevBtnText: '上一步' // Previous button text for this step
      // Called when moving to next step on any step
    })
    if (localStorage.getItem('guild') === 'no') {
      //
    } else {
      this.guide()
    }
  }
  // 操作演示
  guide() {
    this.driver.defineSteps(this.guildData.guildData)
    this.driver.start()
    localStorage.setItem('guild', 'no')
  }
  // 销毁清除定时器
  destroyed() {
    // clearInterval(this.timer)
  }
  // 获取激活的路由
  saveMenu(item: any) {
    // // console.log(this.$route.matched)
    // this.$route.matched.filter(item => // console.log(item))
  }
}
